import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "bg-white rounded-md shadow-md p-5" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-5 mt-5" }
const _hoisted_6 = { class: "flex flex-col col-span-12 md:col-span-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "flex flex-col col-span-12 md:col-span-4" }
const _hoisted_9 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitQuiz && _ctx.submitQuiz(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("quiz.teacher.info")), 1),
            (_ctx.role === 'TEACHER')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  id: "btn-save-info",
                  label: _ctx.$t('labels.save', { pt: 'informações', en: 'info' }),
                  class: "btn-outline p-button-sm",
                  loading: _ctx.loading,
                  type: "submit"
                }, null, 8, ["label", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("quiz.teacher.duration")), 1),
              _createVNode(_component_InputMask, {
                id: "duration-input",
                mask: "99:99",
                modelValue: _ctx.form.duration,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.duration) = $event)),
                placeholder: "00:00",
                class: _normalizeClass(_ctx.v$.form.duration.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.duration.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("quiz.teacher.total")), 1),
              _createVNode(_component_InputNumber, {
                inputId: "total-questions-input",
                modelValue: _ctx.form.numberQuestions,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.numberQuestions) = $event)),
                class: _normalizeClass(_ctx.v$.form.numberQuestions.$error ? 'p-invalid' : ''),
                min: 1,
                max: 100
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.numberQuestions.$errors
              }, null, 8, ["errors"])
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}